(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elavie-faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.efq__list[data-accordion]').forEach(function(list) {
    list.querySelectorAll('.efq__item > summary').forEach(function(sum) {
      sum.addEventListener('click', function() {
        var item = this.parentElement;
        list.querySelectorAll('.efq__item[open]').forEach(function(other) {
          if (other !== item) other.removeAttribute('open');
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elavie-geo-bar"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.egb').forEach(function(bar) {
    var textEl = bar.querySelector('.egb__text');
    var flagEl = bar.querySelector('.egb__flag');
    var prefix = bar.getAttribute('data-prefix') || 'Delivering to';
    var fallback = bar.getAttribute('data-fallback') || 'Worldwide Shipping Available';

    function flagEmoji(iso) {
      if (!iso || iso.length !== 2) return '';
      var A = 0x1F1E6;
      return String.fromCodePoint(A + iso.toUpperCase().charCodeAt(0) - 65, A + iso.toUpperCase().charCodeAt(1) - 65);
    }
    function show(region, country, iso) {
      var loc = region ? region + ', ' + country : country;
      if (textEl) textEl.textContent = prefix + ' ' + loc;
      if (flagEl) flagEl.textContent = flagEmoji(iso);
    }
    function showFallback() {
      var country = bar.getAttribute('data-country');
      var iso = bar.getAttribute('data-iso');
      if (country) { show('', country, iso); }
      else if (textEl) { textEl.textContent = fallback; }
    }

    var timeout = setTimeout(showFallback, 4000);
    fetch('https://ipapi.co/json/')
      .then(function(r) { return r.json(); })
      .then(function(d) {
        clearTimeout(timeout);
        if (d && d.country_name) { show(d.region || '', d.country_name, d.country_code || ''); }
        else { showFallback(); }
      })
      .catch(function() { clearTimeout(timeout); showFallback(); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elavie-header"] && !Shopify.designMode) return;
  try {
    
(function() {
  var wrap = document.querySelector('.elavie-section-header');
  var headerEl = document.getElementById('elhdr-wrap');
  if (headerEl) {
    var setH = function() { document.documentElement.style.setProperty('--elhdr-h', headerEl.offsetHeight + 'px'); };
    setH(); window.addEventListener('resize', setH);
  }

  /* Sticky on-scroll-up (exact Enerra behavior) */
  if (wrap) {
    var lastY = window.scrollY;
    window.addEventListener('scroll', function() {
      var y = window.scrollY;
      if (y > lastY && y > 160) { wrap.classList.add('elhdr--hidden'); }
      else { wrap.classList.remove('elhdr--hidden'); }
      lastY = y;
    }, { passive: true });
  }

  /* Cart icon opens the custom drawer */
  var cartBtn = document.getElementById('elhdr-cart-btn');
  if (cartBtn) {
    cartBtn.addEventListener('click', function(e) {
      if (typeof window.openCartDrawer === 'function') {
        e.preventDefault();
        window.openCartDrawer();
      }
    });
  }

  /* Close open loc dropdowns when clicking outside */
  document.addEventListener('click', function(e) {
    document.querySelectorAll('.eloc[open]').forEach(function(d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elavie-home-products"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.ehp__card').forEach(function(card) {
    var imgs = card.querySelectorAll('.ehp__image');
    var dots = card.querySelectorAll('.ehp__dot');
    if (!imgs.length) return;
    var current = 0;
    function show(i) {
      current = (i + imgs.length) % imgs.length;
      imgs.forEach(function(el, idx) { el.classList.toggle('is-active', idx === current); });
      dots.forEach(function(el, idx) { el.classList.toggle('is-active', idx === current); });
    }
    dots.forEach(function(dot) {
      dot.addEventListener('click', function(e) {
        e.preventDefault(); e.stopPropagation();
        show(parseInt(this.getAttribute('data-i'), 10));
      });
    });
    /* hover → second image (Enerra hover-image-overlay behavior) */
    if (imgs.length > 1) {
      card.addEventListener('mouseenter', function() { if (current === 0) show(1); });
      card.addEventListener('mouseleave', function() { show(0); });
      /* touch swipe */
      var startX = 0, startY = 0;
      var container = card.querySelector('.ehp__image-container');
      if (container) {
        container.addEventListener('touchstart', function(e) {
          var t = e.changedTouches[0]; startX = t.clientX; startY = t.clientY;
        }, { passive: true });
        container.addEventListener('touchend', function(e) {
          var t = e.changedTouches[0];
          var dx = t.clientX - startX, dy = t.clientY - startY;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { show(dx < 0 ? current + 1 : current - 1); }
        }, { passive: true });
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elavie-product-main"] && !Shopify.designMode) return;
  try {
    
(function() {
  var gallery = document.getElementById("pdp-gallery");
  if (gallery) {
    var imgs = gallery.querySelectorAll(".pdp__main-img");
    var thumbs = gallery.querySelectorAll(".pdp__thumb");
    var current = 0;
    function showImg(i) {
      if (!imgs.length) return;
      current = (i + imgs.length) % imgs.length;
      imgs.forEach(function(el, idx) { el.classList.toggle("is-active", idx === current); });
      thumbs.forEach(function(el, idx) { el.classList.toggle("is-active", idx === current); });
      /* keep the active thumb visible in the filmstrip */
      if (thumbs[current] && thumbs[current].scrollIntoView) {
        thumbs[current].scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
      }
    }
    var prev = document.getElementById("pdp-prev");
    var next = document.getElementById("pdp-next");
    if (prev) prev.addEventListener("click", function() { showImg(current - 1); });
    if (next) next.addEventListener("click", function() { showImg(current + 1); });
    thumbs.forEach(function(t) {
      t.addEventListener("click", function() { showImg(parseInt(this.getAttribute("data-i"), 10)); });
    });
    var media = gallery.querySelector(".pdp__main-media");
    if (media && imgs.length > 1) {
      var startX = 0, startY = 0;
      media.addEventListener("touchstart", function(e) {
        var t = e.changedTouches[0]; startX = t.clientX; startY = t.clientY;
      }, { passive: true });
      media.addEventListener("touchend", function(e) {
        var t = e.changedTouches[0];
        var dx = t.clientX - startX, dy = t.clientY - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { showImg(dx < 0 ? current + 1 : current - 1); }
      }, { passive: true });
    }
  }

  /* ATC — AJAX add, open custom drawer (fallback /cart) */
  var form = document.getElementById("pdp-form");
  var variantIdEl = document.getElementById("pdp-variant-id");
  var atcBtn = document.getElementById("pdp-atc");
  var atcOriginal = atcBtn ? atcBtn.innerHTML : "";
  if (form) {
    form.addEventListener("submit", function(e) {
      e.preventDefault();
      var id = variantIdEl ? variantIdEl.value : "";
      if (!id) { form.submit(); return; }
      if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = atcBtn.getAttribute("data-adding-label") || "Adding..."; }
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: id, quantity: 1 })
      }).then(function(r) { return r.json(); }).then(function() {
        if (atcBtn) { atcBtn.innerHTML = atcOriginal; atcBtn.disabled = false; }
        document.dispatchEvent(new CustomEvent("cart:updated"));
        if (typeof window.openCartDrawer === "function") { window.openCartDrawer(); return; }
        window.location.href = "/cart";
      }).catch(function() { form.submit(); });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elavie-sticky-cta"] && !Shopify.designMode) return;
  try {
    
(function() {
  var bar = document.getElementById('elavie-sticky');
  if (!bar) return;
  var buybox = document.querySelector('.pdp');

  function scrollToBuybox() {
    if (buybox) buybox.scrollIntoView({ behavior: 'smooth', block: 'start' });
    else window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  ['elavie-sticky-btn', 'elavie-sticky-btn-mobile'].forEach(function(id) {
    var b = document.getElementById(id);
    if (b) b.addEventListener('click', scrollToBuybox);
  });

  var ticking = false;
  function check() {
    var drawer = document.getElementById('cart-drawer');
    var drawerOpen = drawer && drawer.open;
    var doc = document.documentElement;
    var pct = (window.scrollY / (doc.scrollHeight - window.innerHeight)) * 100;
    if (pct >= 20 && !drawerOpen) { bar.classList.add('is-visible'); }
    else { bar.classList.remove('is-visible'); }
    ticking = false;
  }
  window.addEventListener('scroll', function() {
    if (!ticking) { ticking = true; setTimeout(check, 50); }
  }, { passive: true });
  setTimeout(check, 500);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elavie-testimonials"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.ete__carousel').forEach(function(carousel) {
    var track = carousel.querySelector('.ete__track');
    if (!track) return;
    var prev = carousel.querySelector('.ete__nav-btn--prev');
    var next = carousel.querySelector('.ete__nav-btn--next');
    var dots = carousel.querySelectorAll('.ete__dot');
    var originals = Array.prototype.slice.call(track.querySelectorAll('.ete__card'));
    var n = originals.length;
    if (n < 2) return;

    /* Infinite loop: keep enough cards in the DOM so a slide always reveals a new
       card on the right (and there is never an empty gap on wide screens). The row
       is a repeating pattern of the n originals, so a logical index mod n always
       tells us which review sits on the left. */
    var minCards = Math.max(8, n + 4);
    var copies = Math.ceil(minCards / n);
    for (var c = 1; c < copies; c++) {
      originals.forEach(function(el) {
        var clone = el.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
    }

    var leftIndex = 0;      /* which original (0..n-1) is currently left-most */
    var animating = false;
    function step() { return originals[0].offsetWidth + 20; }

    function updateDots() {
      dots.forEach(function(d, i) { d.classList.toggle('is-active', i === (leftIndex % n)); });
    }
    function afterTransition(cb) {
      var done = false;
      var fire = function() { if (done) return; done = true; track.removeEventListener('transitionend', fire); cb(); };
      track.addEventListener('transitionend', fire);
      setTimeout(fire, 450);
    }

    /* NEXT: slide one card left, then recycle the first card to the end and snap back
       to 0 — seamless, so it never hits an end. */
    function goNext() {
      if (animating) return;
      animating = true;
      track.style.transition = 'transform 0.35s ease';
      track.style.transform = 'translateX(' + (-step()) + 'px)';
      afterTransition(function() {
        track.style.transition = 'none';
        track.appendChild(track.firstElementChild);
        track.style.transform = 'translateX(0)';
        void track.offsetWidth; /* reflow */
        leftIndex = (leftIndex + 1) % n;
        animating = false;
        updateDots();
      });
    }
    /* PREV: put the last card in front off-screen, then slide right into place. */
    function goPrev() {
      if (animating) return;
      animating = true;
      track.style.transition = 'none';
      track.insertBefore(track.lastElementChild, track.firstElementChild);
      track.style.transform = 'translateX(' + (-step()) + 'px)';
      void track.offsetWidth; /* reflow */
      track.style.transition = 'transform 0.35s ease';
      track.style.transform = 'translateX(0)';
      afterTransition(function() {
        track.style.transition = 'none';
        leftIndex = (leftIndex - 1 + n) % n;
        animating = false;
        updateDots();
      });
    }

    if (next) next.addEventListener('click', goNext);
    if (prev) prev.addEventListener('click', goPrev);
    dots.forEach(function(d) {
      d.addEventListener('click', function() {
        if (animating) return;
        var target = parseInt(this.getAttribute('data-i'), 10) || 0;
        var diff = ((target - (leftIndex % n)) % n + n) % n;
        for (var i = 0; i < diff; i++) { track.appendChild(track.firstElementChild); }
        track.style.transition = 'none';
        track.style.transform = 'translateX(0)';
        leftIndex = target;
        updateDots();
      });
    });

    /* Mobile swipe (one card per swipe) — native scroll is off so we handle touch. */
    var x0 = null;
    carousel.addEventListener('touchstart', function(e) { x0 = e.touches[0].clientX; }, { passive: true });
    carousel.addEventListener('touchend', function(e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 40) { if (dx < 0) goNext(); else goPrev(); }
    }, { passive: true });

    updateDots();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elavie-timeline"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.etl').forEach(function(section) {
    var timeline = section.querySelector('.etl__timeline');
    var fill = section.querySelector('.etl__fill');
    var items = section.querySelectorAll('.etl__item');

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) { if (e.isIntersecting) e.target.classList.add('is-in'); });
      }, { threshold: 0.2 });
      items.forEach(function(it) { io.observe(it); });
      /* safety net: content must never stay invisible if IO is throttled/broken */
      setTimeout(function() { items.forEach(function(it) { it.classList.add('is-in'); }); }, 1500);
    } else {
      items.forEach(function(it) { it.classList.add('is-in'); });
    }

    if (timeline && fill) {
      window.addEventListener('scroll', function() {
        var rect = timeline.getBoundingClientRect();
        var vh = window.innerHeight;
        var progress = (vh - rect.top) / (rect.height + vh);
        var pct = Math.max(0, Math.min(1, progress)) * 100;
        fill.style.height = pct + '%';
      }, { passive: true });
    }

    section.querySelectorAll('.el-scroll-buy').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var target = document.querySelector('.pdp');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        else window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elavie-ugc-videos"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* UGC videos: only poster images exist at load. Players are built ONE AT A TIME
     (several decoders at once froze mobile scroll), and only once the page has
     fully loaded AND the user made a first gesture. */
  var posters = [].slice.call(document.querySelectorAll(".euv__poster[data-video-src]"));
  if (!posters.length || !("IntersectionObserver" in window)) return;
  var queue = [];
  var building = false;
  var players = [];
  var ICON_MUTED = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3 3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4 9.91 6.09 12 8.18V4z"/></svg>';
  var ICON_SOUND = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/></svg>';
  var setMuted = function(entry, muted) {
    entry.video.muted = muted;
    entry.btn.innerHTML = muted ? ICON_MUTED : ICON_SOUND;
  };
  var buildNext = function() {
    if (building || !queue.length) return;
    building = true;
    var img = queue.shift();
    if (img.__built) { building = false; buildNext(); return; }
    img.__built = true;
    var thumb = img.parentNode;
    var v = document.createElement("video");
    v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute("playsinline", "");
    v.preload = "metadata";
    v.poster = img.src;
    v.src = img.getAttribute("data-video-src");
    v.style.cssText = "width:100%;height:100%;object-fit:cover;display:block;";
    var done = false;
    var release = function() {
      if (done) return; done = true;
      building = false;
      setTimeout(buildNext, 300);
    };
    v.addEventListener("canplay", release, { once: true });
    setTimeout(release, 2500);
    img.replaceWith(v);
    /* Sound toggle button (exact Enerra) — unmuting one tile mutes the others */
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "euv__sound";
    var strip = thumb ? thumb.closest(".euv__strip") : null;
    btn.setAttribute("aria-label", (strip && strip.getAttribute("data-sound-label")) || "Toggle sound");
    btn.innerHTML = ICON_MUTED;
    var entry = { video: v, btn: btn };
    players.push(entry);
    btn.addEventListener("click", function(e) {
      e.preventDefault();
      e.stopPropagation();
      var wasMuted = v.muted;
      players.forEach(function(other) { setMuted(other, true); });
      if (wasMuted) {
        setMuted(entry, false);
        var pp = v.play(); if (pp && pp.catch) pp.catch(function() {});
      }
    });
    if (thumb) thumb.appendChild(btn);
    var p = v.play(); if (p && p.catch) p.catch(function() {});
  };
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting && !e.target.__queued) {
        e.target.__queued = true;
        queue.push(e.target);
        io.unobserve(e.target);
        buildNext();
      }
    });
  }, { rootMargin: "50px", threshold: 0.1 });
  var armed = false;
  var loaded = document.readyState === "complete";
  var gestured = false;
  var arm = function() {
    if (armed || !loaded || !gestured) return;
    armed = true;
    posters.forEach(function(img) { io.observe(img); });
  };
  if (!loaded) {
    window.addEventListener("load", function() { loaded = true; arm(); }, { once: true });
    setTimeout(function() { loaded = true; arm(); }, 7000);
  }
  var onGesture = function() { gestured = true; arm(); };
  ["touchstart", "scroll", "wheel", "mousemove", "keydown"].forEach(function(evt) {
    window.addEventListener(evt, onGesture, { once: true, passive: true });
  });
  setTimeout(function() { gestured = true; arm(); }, 10000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
